import { Contexts } from '@sentry/core'
import * as Sentry from '@sentry/vue'

const key = 'pageTitle'

/**
 * Context key for page title, which is used for naming grouped issues in Sentry
 */
export function setContextPageTitle(value: string): void {
  Sentry.setContext(key, { value })
}

export function getContextPageTitle(contexts: Contexts | undefined): string {
  const contextPageTitle = contexts?.[key]

  return (contextPageTitle?.value as string) ?? ''
}

export function deleteContextPageTitle(contexts: Contexts | undefined): void {
  delete contexts?.[key]
}

export function setDeviceContext(): void {
  Sentry.setContext('device', {
    screen_height_pixels: screen.height,
    screen_width_pixels: screen.width,
    online: navigator.onLine,
  })
}
